/** Live "{n}/{max}" under a length-capped field. Announces only at the cap. */
export function CharCount({ value, max }: { value: string; max: number }) {
  const n = value.length;
  const atMax = n >= max;
  return (
    <p
      className={`mt-1 text-xs ${atMax ? "text-danger" : "text-muted"}`}
      aria-live={atMax ? "polite" : undefined}
    >
      {n}/{max}
    </p>
  );
}
